var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBMCnt13Ent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 81,
    viewBox: "0 0 550 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 0.999237V79.9992C68 52.4992 99.5 59.4992 205.5 74.9992C283.44 86.3961 479 79.9992 549.943 43.4994L550 33.4994V0.999237H0Z",
    fill: "#524098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 -0.000244141V36.4997C53.5 14.4997 133.5 53.4997 259.5 70.9998C380.039 87.7414 520 76.4996 550 59.4998V-0.000244141H0Z",
    fill: "#524098"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 -0.00063324V59.1256C34.5 37.9994 94.8036 44.4787 221.5 60.4994C329.841 74.199 485 77.4994 549.943 59.4995L550 56.4995V-0.00063324H0Z",
    fill: "#524098"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBMCnt13Ent);
export default __webpack_public_path__ + "static/media/b_m_cnt13_ent.28cd371f513ff721d3d851f5c4e2133e.svg";
export { ForwardRef as ReactComponent };